import { Banner } from "./banner";

export class Settings {

    slides: Banner[];
    topBanner: Banner;
    bottomBanner: Banner;
    Ads1: Banner;
    Ads2: Banner;
    catOrientation;
    catMentoring;
    catMetiers;
    catConseil;
    catVideo;
    appversionname;
    appversionnumber;
    updateapplink;


    constructor() {
        // this.url = "";
        this.slides = [];
    }

   

}
